export default function parseResourceId(id) {
  const regex = /^([a-zA-Z_]+)(-?\d+)$/;
  const match = `${id || ""}`.match(regex);

  return [Array.isArray(match) ? match[1] : null, Array.isArray(match) ? parseInt(match[2], 10) : null];
}
